var _desc, _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _rect331, _rect332, _rect333, _rect334, _rect335, _rect336, _rect337, _rect338, _rect339, _rect340, _rect341, _rect342, _rect343, _rect344, _rect345, _rect346, _rect347, _rect348, _rect349, _rect350, _rect351, _rect352, _rect353, _rect354, _rect355, _rect356, _rect357, _rect358, _rect359, _rect360, _rect361, _rect362, _rect363, _rect364, _rect365, _rect366, _rect367, _rect368, _rect369, _rect370, _rect371, _rect372, _rect373, _rect374, _rect375, _rect376;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGitsvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-16 -32 880 192",
    width: 880,
    height: 192,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Generated with https://github.com/Platane/snk")), _style || (_style = /*#__PURE__*/React.createElement("style", null, ":root{--cb:#1b1f230a;--cs:purple;--ce:#161b22;--c0:#161b22;--c1:#01311f;--c2:#034525;--c3:#0f6d31;--c4:#00c647}.c{shape-rendering:geometricPrecision;fill:var(--ce);stroke-width:1px;stroke:var(--cb);animation:none 32100ms linear infinite;width:12px;height:12px}@keyframes c0{1.55%{fill:var(--c1)}1.57%,100%{fill:var(--ce)}}.c.c0{fill:var(--c1);animation-name:c0}@keyframes c1{55.13%{fill:var(--c1)}55.15%,100%{fill:var(--ce)}}.c.c1{fill:var(--c1);animation-name:c1}@keyframes c2{6.84%{fill:var(--c1)}6.86%,100%{fill:var(--ce)}}.c.c2{fill:var(--c1);animation-name:c2}@keyframes c3{54.51%{fill:var(--c1)}54.53%,100%{fill:var(--ce)}}.c.c3{fill:var(--c1);animation-name:c3}@keyframes c4{7.47%{fill:var(--c1)}7.49%,100%{fill:var(--ce)}}.c.c4{fill:var(--c1);animation-name:c4}@keyframes c5{8.4%{fill:var(--c1)}8.42%,100%{fill:var(--ce)}}.c.c5{fill:var(--c1);animation-name:c5}@keyframes c6{16.19%{fill:var(--c1)}16.21%,100%{fill:var(--ce)}}.c.c6{fill:var(--c1);animation-name:c6}@keyframes c7{60.11%{fill:var(--c2)}60.13%,100%{fill:var(--ce)}}.c.c7{fill:var(--c2);animation-name:c7}@keyframes c8{9.02%{fill:var(--c1)}9.04%,100%{fill:var(--ce)}}.c.c8{fill:var(--c1);animation-name:c8}@keyframes c9{16.5%{fill:var(--c1)}16.52%,100%{fill:var(--ce)}}.c.c9{fill:var(--c1);animation-name:c9}@keyframes ca{13.07%{fill:var(--c1)}13.09%,100%{fill:var(--ce)}}.c.ca{fill:var(--c1);animation-name:ca}@keyframes cb{60.74%{fill:var(--c2)}60.76%,100%{fill:var(--ce)}}.c.cb{fill:var(--c2);animation-name:cb}@keyframes cc{57.93%{fill:var(--c1)}57.95%,100%{fill:var(--ce)}}.c.cc{fill:var(--c1);animation-name:cc}@keyframes cd{61.36%{fill:var(--c2)}61.38%,100%{fill:var(--ce)}}.c.cd{fill:var(--c2);animation-name:cd}@keyframes ce{17.12%{fill:var(--c1)}17.14%,100%{fill:var(--ce)}}.c.ce{fill:var(--c1);animation-name:ce}@keyframes cf{62.3%{fill:var(--c2)}62.32%,100%{fill:var(--ce)}}.c.cf{fill:var(--c2);animation-name:cf}@keyframes cg{58.56%{fill:var(--c1)}58.58%,100%{fill:var(--ce)}}.c.cg{fill:var(--c1);animation-name:cg}@keyframes ch{58.25%{fill:var(--c2)}58.27%,100%{fill:var(--ce)}}.c.ch{fill:var(--c2);animation-name:ch}@keyframes ci{9.65%{fill:var(--c1)}9.67%,100%{fill:var(--ce)}}.c.ci{fill:var(--c1);animation-name:ci}@keyframes cj{17.44%{fill:var(--c1)}17.46%,100%{fill:var(--ce)}}.c.cj{fill:var(--c1);animation-name:cj}@keyframes ck{58.87%{fill:var(--c2)}58.89%,100%{fill:var(--ce)}}.c.ck{fill:var(--c2);animation-name:ck}@keyframes cl{9.96%{fill:var(--c1)}9.98%,100%{fill:var(--ce)}}.c.cl{fill:var(--c1);animation-name:cl}@keyframes cm{62.92%{fill:var(--c2)}62.94%,100%{fill:var(--ce)}}.c.cm{fill:var(--c2);animation-name:cm}@keyframes cn{10.58%{fill:var(--c1)}10.6%,100%{fill:var(--ce)}}.c.cn{fill:var(--c1);animation-name:cn}@keyframes co{63.23%{fill:var(--c2)}63.25%,100%{fill:var(--ce)}}.c.co{fill:var(--c2);animation-name:co}@keyframes cp{11.83%{fill:var(--c1)}11.85%,100%{fill:var(--ce)}}.c.cp{fill:var(--c1);animation-name:cp}@keyframes cq{11.2%{fill:var(--c1)}11.22%,100%{fill:var(--ce)}}.c.cq{fill:var(--c1);animation-name:cq}@keyframes cr{19.93%{fill:var(--c1)}19.95%,100%{fill:var(--ce)}}.c.cr{fill:var(--c1);animation-name:cr}@keyframes cs{19.3%{fill:var(--c1)}19.32%,100%{fill:var(--ce)}}.c.cs{fill:var(--c1);animation-name:cs}@keyframes ct{64.79%{fill:var(--c2)}64.81%,100%{fill:var(--ce)}}.c.ct{fill:var(--c2);animation-name:ct}@keyframes cu{76.94%{fill:var(--c3)}76.96%,100%{fill:var(--ce)}}.c.cu{fill:var(--c3);animation-name:cu}@keyframes cv{26.78%{fill:var(--c1)}26.8%,100%{fill:var(--ce)}}.c.cv{fill:var(--c1);animation-name:cv}@keyframes cw{27.72%{fill:var(--c1)}27.74%,100%{fill:var(--ce)}}.c.cw{fill:var(--c1);animation-name:cw}@keyframes cx{24.29%{fill:var(--c1)}24.31%,100%{fill:var(--ce)}}.c.cx{fill:var(--c1);animation-name:cx}@keyframes cy{76.31%{fill:var(--c3)}76.33%,100%{fill:var(--ce)}}.c.cy{fill:var(--c3);animation-name:cy}@keyframes cz{26.16%{fill:var(--c1)}26.18%,100%{fill:var(--ce)}}.c.cz{fill:var(--c1);animation-name:cz}@keyframes c10{21.8%{fill:var(--c1)}21.82%,100%{fill:var(--ce)}}.c.c10{fill:var(--c1);animation-name:c10}@keyframes c11{21.49%{fill:var(--c1)}21.51%,100%{fill:var(--ce)}}.c.c11{fill:var(--c1);animation-name:c11}@keyframes c12{23.98%{fill:var(--c1)}24%,100%{fill:var(--ce)}}.c.c12{fill:var(--c1);animation-name:c12}@keyframes c13{23.67%{fill:var(--c1)}23.69%,100%{fill:var(--ce)}}.c.c13{fill:var(--c1);animation-name:c13}@keyframes c14{22.42%{fill:var(--c1)}22.44%,100%{fill:var(--ce)}}.c.c14{fill:var(--c1);animation-name:c14}@keyframes c15{23.04%{fill:var(--c1)}23.06%,100%{fill:var(--ce)}}.c.c15{fill:var(--c1);animation-name:c15}@keyframes c16{28.96%{fill:var(--c1)}28.98%,100%{fill:var(--ce)}}.c.c16{fill:var(--c1);animation-name:c16}@keyframes c17{47.03%{fill:var(--c1)}47.05%,100%{fill:var(--ce)}}.c.c17{fill:var(--c1);animation-name:c17}@keyframes c18{45.47%{fill:var(--c1)}45.49%,100%{fill:var(--ce)}}.c.c18{fill:var(--c1);animation-name:c18}@keyframes c19{67.59%{fill:var(--c2)}67.61%,100%{fill:var(--ce)}}.c.c19{fill:var(--c2);animation-name:c19}@keyframes c1a{30.83%{fill:var(--c1)}30.85%,100%{fill:var(--ce)}}.c.c1a{fill:var(--c1);animation-name:c1a}@keyframes c1b{44.85%{fill:var(--c1)}44.87%,100%{fill:var(--ce)}}.c.c1b{fill:var(--c1);animation-name:c1b}@keyframes c1c{30.21%{fill:var(--c1)}30.23%,100%{fill:var(--ce)}}.c.c1c{fill:var(--c1);animation-name:c1c}@keyframes c1d{44.23%{fill:var(--c1)}44.25%,100%{fill:var(--ce)}}.c.c1d{fill:var(--c1);animation-name:c1d}@keyframes c1e{73.82%{fill:var(--c3)}73.84%,100%{fill:var(--ce)}}.c.c1e{fill:var(--c3);animation-name:c1e}@keyframes c1f{69.15%{fill:var(--c2)}69.17%,100%{fill:var(--ce)}}.c.c1f{fill:var(--c2);animation-name:c1f}@keyframes c1g{42.67%{fill:var(--c1)}42.69%,100%{fill:var(--ce)}}.c.c1g{fill:var(--c1);animation-name:c1g}@keyframes c1h{43.29%{fill:var(--c1)}43.31%,100%{fill:var(--ce)}}.c.c1h{fill:var(--c1);animation-name:c1h}@keyframes c1i{32.7%{fill:var(--c1)}32.72%,100%{fill:var(--ce)}}.c.c1i{fill:var(--c1);animation-name:c1i}@keyframes c1j{32.39%{fill:var(--c1)}32.41%,100%{fill:var(--ce)}}.c.c1j{fill:var(--c1);animation-name:c1j}@keyframes c1k{84.41%{fill:var(--c4)}84.43%,100%{fill:var(--ce)}}.c.c1k{fill:var(--c4);animation-name:c1k}@keyframes c1l{82.54%{fill:var(--c4)}82.56%,100%{fill:var(--ce)}}.c.c1l{fill:var(--c4);animation-name:c1l}@keyframes c1m{70.39%{fill:var(--c2)}70.41%,100%{fill:var(--ce)}}.c.c1m{fill:var(--c2);animation-name:c1m}@keyframes c1n{81.3%{fill:var(--c4)}81.32%,100%{fill:var(--ce)}}.c.c1n{fill:var(--c4);animation-name:c1n}@keyframes c1o{33.32%{fill:var(--c1)}33.34%,100%{fill:var(--ce)}}.c.c1o{fill:var(--c1);animation-name:c1o}@keyframes c1p{83.48%{fill:var(--c4)}83.5%,100%{fill:var(--ce)}}.c.c1p{fill:var(--c4);animation-name:c1p}@keyframes c1q{34.57%{fill:var(--c1)}34.59%,100%{fill:var(--ce)}}.c.c1q{fill:var(--c1);animation-name:c1q}@keyframes c1r{41.11%{fill:var(--c1)}41.13%,100%{fill:var(--ce)}}.c.c1r{fill:var(--c1);animation-name:c1r}@keyframes c1s{72.26%{fill:var(--c2)}72.28%,100%{fill:var(--ce)}}.c.c1s{fill:var(--c2);animation-name:c1s}@keyframes c1t{36.44%{fill:var(--c1)}36.46%,100%{fill:var(--ce)}}.c.c1t{fill:var(--c1);animation-name:c1t}@keyframes c1u{39.87%{fill:var(--c1)}39.89%,100%{fill:var(--ce)}}.c.c1u{fill:var(--c1);animation-name:c1u}@keyframes c1v{39.55%{fill:var(--c1)}39.57%,100%{fill:var(--ce)}}.c.c1v{fill:var(--c1);animation-name:c1v}@keyframes c1w{38.62%{fill:var(--c1)}38.64%,100%{fill:var(--ce)}}.c.c1w{fill:var(--c1);animation-name:c1w}@keyframes c1x{37.68%{fill:var(--c1)}37.7%,100%{fill:var(--ce)}}.c.c1x{fill:var(--c1);animation-name:c1x}.u{transform-origin:0 0;transform:scale(0,1);animation:none linear 32100ms infinite}@keyframes u0{1.55%{transform:scale(0.000,1)}1.57%,6.84%{transform:scale(0.020,1)}6.86%,7.47%{transform:scale(0.041,1)}7.49%,8.4%{transform:scale(0.061,1)}8.42%,9.02%{transform:scale(0.082,1)}9.04%,9.65%{transform:scale(0.102,1)}9.67%,9.96%{transform:scale(0.122,1)}9.98%,10.58%{transform:scale(0.143,1)}10.6%,11.2%{transform:scale(0.163,1)}11.22%,11.83%{transform:scale(0.184,1)}11.85%,13.07%{transform:scale(0.204,1)}13.09%,16.19%{transform:scale(0.224,1)}16.21%,16.5%{transform:scale(0.245,1)}16.52%,17.12%{transform:scale(0.265,1)}17.14%,17.44%{transform:scale(0.286,1)}17.46%,19.3%{transform:scale(0.306,1)}19.32%,19.93%{transform:scale(0.327,1)}19.95%,21.49%{transform:scale(0.347,1)}21.51%,21.8%{transform:scale(0.367,1)}21.82%,22.42%{transform:scale(0.388,1)}22.44%,23.04%{transform:scale(0.408,1)}23.06%,23.67%{transform:scale(0.429,1)}23.69%,23.98%{transform:scale(0.449,1)}24%,24.29%{transform:scale(0.469,1)}24.31%,26.16%{transform:scale(0.490,1)}26.18%,26.78%{transform:scale(0.510,1)}26.8%,27.72%{transform:scale(0.531,1)}27.74%,28.96%{transform:scale(0.551,1)}28.98%,30.21%{transform:scale(0.571,1)}30.23%,30.83%{transform:scale(0.592,1)}30.85%,32.39%{transform:scale(0.612,1)}32.41%,32.7%{transform:scale(0.633,1)}32.72%,33.32%{transform:scale(0.653,1)}33.34%,34.57%{transform:scale(0.673,1)}34.59%,36.44%{transform:scale(0.694,1)}36.46%,37.68%{transform:scale(0.714,1)}37.7%,38.62%{transform:scale(0.735,1)}38.64%,39.55%{transform:scale(0.755,1)}39.57%,39.87%{transform:scale(0.776,1)}39.89%,41.11%{transform:scale(0.796,1)}41.13%,42.67%{transform:scale(0.816,1)}42.69%,43.29%{transform:scale(0.837,1)}43.31%,44.23%{transform:scale(0.857,1)}44.25%,44.85%{transform:scale(0.878,1)}44.87%,45.47%{transform:scale(0.898,1)}45.49%,47.03%{transform:scale(0.918,1)}47.05%,54.51%{transform:scale(0.939,1)}54.53%,55.13%{transform:scale(0.959,1)}55.15%,57.93%{transform:scale(0.980,1)}57.95%,100%{transform:scale(1.000,1)}}.u.u0{fill:var(--c1);animation-name:u0;transform-origin:0.0px 0}@keyframes u1{58.25%{transform:scale(0.000,1)}58.27%,100%{transform:scale(1.000,1)}}.u.u1{fill:var(--c2);animation-name:u1;transform-origin:593.6px 0}@keyframes u2{58.56%{transform:scale(0.000,1)}58.58%,100%{transform:scale(1.000,1)}}.u.u2{fill:var(--c1);animation-name:u2;transform-origin:605.7px 0}@keyframes u3{58.87%{transform:scale(0.000,1)}58.89%,60.11%{transform:scale(0.083,1)}60.13%,60.74%{transform:scale(0.167,1)}60.76%,61.36%{transform:scale(0.250,1)}61.38%,62.3%{transform:scale(0.333,1)}62.32%,62.92%{transform:scale(0.417,1)}62.94%,63.23%{transform:scale(0.500,1)}63.25%,64.79%{transform:scale(0.583,1)}64.81%,67.59%{transform:scale(0.667,1)}67.61%,69.15%{transform:scale(0.750,1)}69.17%,70.39%{transform:scale(0.833,1)}70.41%,72.26%{transform:scale(0.917,1)}72.28%,100%{transform:scale(1.000,1)}}.u.u3{fill:var(--c2);animation-name:u3;transform-origin:617.8px 0}@keyframes u4{73.82%{transform:scale(0.000,1)}73.84%,76.31%{transform:scale(0.333,1)}76.33%,76.94%{transform:scale(0.667,1)}76.96%,100%{transform:scale(1.000,1)}}.u.u4{fill:var(--c3);animation-name:u4;transform-origin:763.2px 0}@keyframes u5{81.3%{transform:scale(0.000,1)}81.32%,82.54%{transform:scale(0.250,1)}82.56%,83.48%{transform:scale(0.500,1)}83.5%,84.41%{transform:scale(0.750,1)}84.43%,100%{transform:scale(1.000,1)}}.u.u5{fill:var(--c4);animation-name:u5;transform-origin:799.5px 0}.s{shape-rendering:geometricPrecision;fill:var(--cs);animation:none linear 32100ms infinite}@keyframes s0{0%,99.69%{transform:translate(0px,-16px)}0.31%{transform:translate(0px,0px)}1.25%{transform:translate(48px,0px)}1.56%{transform:translate(48px,16px)}6.54%{transform:translate(304px,16px)}6.85%{transform:translate(304px,0px)}7.48%{transform:translate(336px,0px)}8.41%{transform:translate(336px,48px)}8.72%{transform:translate(352px,48px)}9.03%{transform:translate(352px,64px)}10.28%{transform:translate(416px,64px)}10.59%{transform:translate(416px,48px)}10.9%{transform:translate(432px,48px)}11.84%{transform:translate(432px,0px)}13.08%{transform:translate(368px,0px)}13.4%{transform:translate(368px,-16px)}14.02%{transform:translate(336px,-16px)}16.2%{transform:translate(336px,96px)}16.51%{transform:translate(352px,96px)}16.82%{transform:translate(352px,80px)}19.31%{transform:translate(480px,80px)}19.63%{transform:translate(480px,96px)}19.94%{transform:translate(464px,96px)}20.25%{transform:translate(464px,80px)}21.5%{transform:translate(528px,80px)}22.12%{transform:translate(528px,48px)}22.74%{transform:translate(560px,48px)}23.36%{transform:translate(560px,16px)}23.68%{transform:translate(544px,16px)}23.99%,48.29%{transform:translate(544px,0px)}24.3%,76.64%{transform:translate(528px,0px)}24.61%{transform:translate(528px,-16px)}24.92%{transform:translate(544px,-16px)}25.86%,48.91%{transform:translate(544px,32px)}26.48%{transform:translate(512px,32px)}27.73%{transform:translate(512px,96px)}28.66%{transform:translate(560px,96px)}28.97%{transform:translate(560px,80px)}30.22%{transform:translate(624px,80px)}30.53%{transform:translate(624px,96px)}30.84%,66.98%{transform:translate(608px,96px)}31.15%{transform:translate(608px,80px)}32.4%,84.11%{transform:translate(672px,80px)}32.71%{transform:translate(672px,64px)}33.64%{transform:translate(720px,64px)}34.27%,71.03%{transform:translate(720px,96px)}34.58%{transform:translate(704px,96px)}34.89%{transform:translate(704px,112px)}36.14%{transform:translate(768px,112px)}36.45%{transform:translate(768px,96px)}37.38%{transform:translate(816px,96px)}39.25%{transform:translate(816px,0px)}41.12%{transform:translate(720px,0px)}41.43%{transform:translate(720px,-16px)}42.37%{transform:translate(672px,-16px)}43.3%{transform:translate(672px,32px)}43.93%{transform:translate(640px,32px)}44.24%{transform:translate(640px,16px)}44.55%{transform:translate(624px,16px)}44.86%{transform:translate(624px,32px)}45.17%{transform:translate(608px,32px)}45.48%{transform:translate(608px,48px)}45.79%{transform:translate(624px,48px)}46.73%{transform:translate(624px,0px)}51.71%{transform:translate(400px,32px)}52.02%{transform:translate(400px,48px)}52.34%{transform:translate(384px,48px)}52.65%{transform:translate(384px,64px)}53.89%{transform:translate(320px,64px)}54.52%{transform:translate(320px,96px)}55.14%{transform:translate(288px,96px)}56.39%{transform:translate(288px,32px)}58.26%{transform:translate(384px,32px)}58.57%{transform:translate(384px,16px)}58.88%{transform:translate(400px,16px)}59.19%{transform:translate(400px,0px)}60.12%{transform:translate(352px,0px)}60.44%{transform:translate(352px,16px)}60.75%{transform:translate(368px,16px)}62.31%{transform:translate(368px,96px)}67.6%{transform:translate(608px,64px)}68.54%{transform:translate(656px,64px)}69.47%{transform:translate(656px,112px)}70.09%{transform:translate(688px,112px)}70.4%{transform:translate(688px,96px)}72.59%{transform:translate(720px,16px)}76.32%{transform:translate(528px,16px)}76.95%{transform:translate(512px,0px)}77.26%{transform:translate(512px,-16px)}81%{transform:translate(704px,-16px)}81.31%{transform:translate(704px,0px)}81.62%{transform:translate(688px,0px)}82.55%{transform:translate(688px,48px)}82.87%{transform:translate(704px,48px)}83.49%{transform:translate(704px,80px)}84.42%{transform:translate(672px,96px)}92.52%{transform:translate(256px,96px)}93.15%{transform:translate(256px,64px)}93.46%{transform:translate(240px,64px)}94.08%{transform:translate(240px,32px)}95.64%{transform:translate(160px,32px)}95.95%{transform:translate(160px,16px)}96.57%{transform:translate(128px,16px)}96.88%{transform:translate(128px,0px)}98.13%{transform:translate(64px,0px)}98.44%{transform:translate(64px,-16px)}}.s.s0{transform:translate(0px,-16px);animation-name:s0}@keyframes s1{0%,99.69%{transform:translate(16px,-16px)}0.31%{transform:translate(0px,-16px)}0.62%{transform:translate(0px,0px)}1.56%{transform:translate(48px,0px)}1.87%{transform:translate(48px,16px)}6.85%{transform:translate(304px,16px)}7.17%{transform:translate(304px,0px)}7.79%{transform:translate(336px,0px)}8.72%{transform:translate(336px,48px)}9.03%{transform:translate(352px,48px)}9.35%{transform:translate(352px,64px)}10.59%{transform:translate(416px,64px)}10.9%{transform:translate(416px,48px)}11.21%{transform:translate(432px,48px)}12.15%{transform:translate(432px,0px)}13.4%{transform:translate(368px,0px)}13.71%{transform:translate(368px,-16px)}14.33%{transform:translate(336px,-16px)}16.51%{transform:translate(336px,96px)}16.82%{transform:translate(352px,96px)}17.13%{transform:translate(352px,80px)}19.63%{transform:translate(480px,80px)}19.94%{transform:translate(480px,96px)}20.25%{transform:translate(464px,96px)}20.56%{transform:translate(464px,80px)}21.81%{transform:translate(528px,80px)}22.43%{transform:translate(528px,48px)}23.05%{transform:translate(560px,48px)}23.68%{transform:translate(560px,16px)}23.99%{transform:translate(544px,16px)}24.3%,48.6%{transform:translate(544px,0px)}24.61%,76.95%{transform:translate(528px,0px)}24.92%{transform:translate(528px,-16px)}25.23%{transform:translate(544px,-16px)}26.17%,49.22%{transform:translate(544px,32px)}26.79%{transform:translate(512px,32px)}28.04%{transform:translate(512px,96px)}28.97%{transform:translate(560px,96px)}29.28%{transform:translate(560px,80px)}30.53%{transform:translate(624px,80px)}30.84%{transform:translate(624px,96px)}31.15%,67.29%{transform:translate(608px,96px)}31.46%{transform:translate(608px,80px)}32.71%,84.42%{transform:translate(672px,80px)}33.02%{transform:translate(672px,64px)}33.96%{transform:translate(720px,64px)}34.58%,71.34%{transform:translate(720px,96px)}34.89%{transform:translate(704px,96px)}35.2%{transform:translate(704px,112px)}36.45%{transform:translate(768px,112px)}36.76%{transform:translate(768px,96px)}37.69%{transform:translate(816px,96px)}39.56%{transform:translate(816px,0px)}41.43%{transform:translate(720px,0px)}41.74%{transform:translate(720px,-16px)}42.68%{transform:translate(672px,-16px)}43.61%{transform:translate(672px,32px)}44.24%{transform:translate(640px,32px)}44.55%{transform:translate(640px,16px)}44.86%{transform:translate(624px,16px)}45.17%{transform:translate(624px,32px)}45.48%{transform:translate(608px,32px)}45.79%{transform:translate(608px,48px)}46.11%{transform:translate(624px,48px)}47.04%{transform:translate(624px,0px)}52.02%{transform:translate(400px,32px)}52.34%{transform:translate(400px,48px)}52.65%{transform:translate(384px,48px)}52.96%{transform:translate(384px,64px)}54.21%{transform:translate(320px,64px)}54.83%{transform:translate(320px,96px)}55.45%{transform:translate(288px,96px)}56.7%{transform:translate(288px,32px)}58.57%{transform:translate(384px,32px)}58.88%{transform:translate(384px,16px)}59.19%{transform:translate(400px,16px)}59.5%{transform:translate(400px,0px)}60.44%{transform:translate(352px,0px)}60.75%{transform:translate(352px,16px)}61.06%{transform:translate(368px,16px)}62.62%{transform:translate(368px,96px)}67.91%{transform:translate(608px,64px)}68.85%{transform:translate(656px,64px)}69.78%{transform:translate(656px,112px)}70.4%{transform:translate(688px,112px)}70.72%{transform:translate(688px,96px)}72.9%{transform:translate(720px,16px)}76.64%{transform:translate(528px,16px)}77.26%{transform:translate(512px,0px)}77.57%{transform:translate(512px,-16px)}81.31%{transform:translate(704px,-16px)}81.62%{transform:translate(704px,0px)}81.93%{transform:translate(688px,0px)}82.87%{transform:translate(688px,48px)}83.18%{transform:translate(704px,48px)}83.8%{transform:translate(704px,80px)}84.74%{transform:translate(672px,96px)}92.83%{transform:translate(256px,96px)}93.46%{transform:translate(256px,64px)}93.77%{transform:translate(240px,64px)}94.39%{transform:translate(240px,32px)}95.95%{transform:translate(160px,32px)}96.26%{transform:translate(160px,16px)}96.88%{transform:translate(128px,16px)}97.2%{transform:translate(128px,0px)}98.44%{transform:translate(64px,0px)}98.75%{transform:translate(64px,-16px)}}.s.s1{transform:translate(16px,-16px);animation-name:s1}@keyframes s2{0%,99.69%{transform:translate(32px,-16px)}0.62%{transform:translate(0px,-16px)}0.93%{transform:translate(0px,0px)}1.87%{transform:translate(48px,0px)}2.18%{transform:translate(48px,16px)}7.17%{transform:translate(304px,16px)}7.48%{transform:translate(304px,0px)}8.1%{transform:translate(336px,0px)}9.03%{transform:translate(336px,48px)}9.35%{transform:translate(352px,48px)}9.66%{transform:translate(352px,64px)}10.9%{transform:translate(416px,64px)}11.21%{transform:translate(416px,48px)}11.53%{transform:translate(432px,48px)}12.46%{transform:translate(432px,0px)}13.71%{transform:translate(368px,0px)}14.02%{transform:translate(368px,-16px)}14.64%{transform:translate(336px,-16px)}16.82%{transform:translate(336px,96px)}17.13%{transform:translate(352px,96px)}17.45%{transform:translate(352px,80px)}19.94%{transform:translate(480px,80px)}20.25%{transform:translate(480px,96px)}20.56%{transform:translate(464px,96px)}20.87%{transform:translate(464px,80px)}22.12%{transform:translate(528px,80px)}22.74%{transform:translate(528px,48px)}23.36%{transform:translate(560px,48px)}23.99%{transform:translate(560px,16px)}24.3%{transform:translate(544px,16px)}24.61%,48.91%{transform:translate(544px,0px)}24.92%,77.26%{transform:translate(528px,0px)}25.23%{transform:translate(528px,-16px)}25.55%{transform:translate(544px,-16px)}26.48%,49.53%{transform:translate(544px,32px)}27.1%{transform:translate(512px,32px)}28.35%{transform:translate(512px,96px)}29.28%{transform:translate(560px,96px)}29.6%{transform:translate(560px,80px)}30.84%{transform:translate(624px,80px)}31.15%{transform:translate(624px,96px)}31.46%,67.6%{transform:translate(608px,96px)}31.78%{transform:translate(608px,80px)}33.02%,84.74%{transform:translate(672px,80px)}33.33%{transform:translate(672px,64px)}34.27%{transform:translate(720px,64px)}34.89%,71.65%{transform:translate(720px,96px)}35.2%{transform:translate(704px,96px)}35.51%{transform:translate(704px,112px)}36.76%{transform:translate(768px,112px)}37.07%{transform:translate(768px,96px)}38.01%{transform:translate(816px,96px)}39.88%{transform:translate(816px,0px)}41.74%{transform:translate(720px,0px)}42.06%{transform:translate(720px,-16px)}42.99%{transform:translate(672px,-16px)}43.93%{transform:translate(672px,32px)}44.55%{transform:translate(640px,32px)}44.86%{transform:translate(640px,16px)}45.17%{transform:translate(624px,16px)}45.48%{transform:translate(624px,32px)}45.79%{transform:translate(608px,32px)}46.11%{transform:translate(608px,48px)}46.42%{transform:translate(624px,48px)}47.35%{transform:translate(624px,0px)}52.34%{transform:translate(400px,32px)}52.65%{transform:translate(400px,48px)}52.96%{transform:translate(384px,48px)}53.27%{transform:translate(384px,64px)}54.52%{transform:translate(320px,64px)}55.14%{transform:translate(320px,96px)}55.76%{transform:translate(288px,96px)}57.01%{transform:translate(288px,32px)}58.88%{transform:translate(384px,32px)}59.19%{transform:translate(384px,16px)}59.5%{transform:translate(400px,16px)}59.81%{transform:translate(400px,0px)}60.75%{transform:translate(352px,0px)}61.06%{transform:translate(352px,16px)}61.37%{transform:translate(368px,16px)}62.93%{transform:translate(368px,96px)}68.22%{transform:translate(608px,64px)}69.16%{transform:translate(656px,64px)}70.09%{transform:translate(656px,112px)}70.72%{transform:translate(688px,112px)}71.03%{transform:translate(688px,96px)}73.21%{transform:translate(720px,16px)}76.95%{transform:translate(528px,16px)}77.57%{transform:translate(512px,0px)}77.88%{transform:translate(512px,-16px)}81.62%{transform:translate(704px,-16px)}81.93%{transform:translate(704px,0px)}82.24%{transform:translate(688px,0px)}83.18%{transform:translate(688px,48px)}83.49%{transform:translate(704px,48px)}84.11%{transform:translate(704px,80px)}85.05%{transform:translate(672px,96px)}93.15%{transform:translate(256px,96px)}93.77%{transform:translate(256px,64px)}94.08%{transform:translate(240px,64px)}94.7%{transform:translate(240px,32px)}96.26%{transform:translate(160px,32px)}96.57%{transform:translate(160px,16px)}97.2%{transform:translate(128px,16px)}97.51%{transform:translate(128px,0px)}98.75%{transform:translate(64px,0px)}99.07%{transform:translate(64px,-16px)}}.s.s2{transform:translate(32px,-16px);animation-name:s2}@keyframes s3{0%,99.69%{transform:translate(48px,-16px)}0.93%{transform:translate(0px,-16px)}1.25%{transform:translate(0px,0px)}2.18%{transform:translate(48px,0px)}2.49%{transform:translate(48px,16px)}7.48%{transform:translate(304px,16px)}7.79%{transform:translate(304px,0px)}8.41%{transform:translate(336px,0px)}9.35%{transform:translate(336px,48px)}9.66%{transform:translate(352px,48px)}9.97%{transform:translate(352px,64px)}11.21%{transform:translate(416px,64px)}11.53%{transform:translate(416px,48px)}11.84%{transform:translate(432px,48px)}12.77%{transform:translate(432px,0px)}14.02%{transform:translate(368px,0px)}14.33%{transform:translate(368px,-16px)}14.95%{transform:translate(336px,-16px)}17.13%{transform:translate(336px,96px)}17.45%{transform:translate(352px,96px)}17.76%{transform:translate(352px,80px)}20.25%{transform:translate(480px,80px)}20.56%{transform:translate(480px,96px)}20.87%{transform:translate(464px,96px)}21.18%{transform:translate(464px,80px)}22.43%{transform:translate(528px,80px)}23.05%{transform:translate(528px,48px)}23.68%{transform:translate(560px,48px)}24.3%{transform:translate(560px,16px)}24.61%{transform:translate(544px,16px)}24.92%,49.22%{transform:translate(544px,0px)}25.23%,77.57%{transform:translate(528px,0px)}25.55%{transform:translate(528px,-16px)}25.86%{transform:translate(544px,-16px)}26.79%,49.84%{transform:translate(544px,32px)}27.41%{transform:translate(512px,32px)}28.66%{transform:translate(512px,96px)}29.6%{transform:translate(560px,96px)}29.91%{transform:translate(560px,80px)}31.15%{transform:translate(624px,80px)}31.46%{transform:translate(624px,96px)}31.78%,67.91%{transform:translate(608px,96px)}32.09%{transform:translate(608px,80px)}33.33%,85.05%{transform:translate(672px,80px)}33.64%{transform:translate(672px,64px)}34.58%{transform:translate(720px,64px)}35.2%,71.96%{transform:translate(720px,96px)}35.51%{transform:translate(704px,96px)}35.83%{transform:translate(704px,112px)}37.07%{transform:translate(768px,112px)}37.38%{transform:translate(768px,96px)}38.32%{transform:translate(816px,96px)}40.19%{transform:translate(816px,0px)}42.06%{transform:translate(720px,0px)}42.37%{transform:translate(720px,-16px)}43.3%{transform:translate(672px,-16px)}44.24%{transform:translate(672px,32px)}44.86%{transform:translate(640px,32px)}45.17%{transform:translate(640px,16px)}45.48%{transform:translate(624px,16px)}45.79%{transform:translate(624px,32px)}46.11%{transform:translate(608px,32px)}46.42%{transform:translate(608px,48px)}46.73%{transform:translate(624px,48px)}47.66%{transform:translate(624px,0px)}52.65%{transform:translate(400px,32px)}52.96%{transform:translate(400px,48px)}53.27%{transform:translate(384px,48px)}53.58%{transform:translate(384px,64px)}54.83%{transform:translate(320px,64px)}55.45%{transform:translate(320px,96px)}56.07%{transform:translate(288px,96px)}57.32%{transform:translate(288px,32px)}59.19%{transform:translate(384px,32px)}59.5%{transform:translate(384px,16px)}59.81%{transform:translate(400px,16px)}60.12%{transform:translate(400px,0px)}61.06%{transform:translate(352px,0px)}61.37%{transform:translate(352px,16px)}61.68%{transform:translate(368px,16px)}63.24%{transform:translate(368px,96px)}68.54%{transform:translate(608px,64px)}69.47%{transform:translate(656px,64px)}70.4%{transform:translate(656px,112px)}71.03%{transform:translate(688px,112px)}71.34%{transform:translate(688px,96px)}73.52%{transform:translate(720px,16px)}77.26%{transform:translate(528px,16px)}77.88%{transform:translate(512px,0px)}78.19%{transform:translate(512px,-16px)}81.93%{transform:translate(704px,-16px)}82.24%{transform:translate(704px,0px)}82.55%{transform:translate(688px,0px)}83.49%{transform:translate(688px,48px)}83.8%{transform:translate(704px,48px)}84.42%{transform:translate(704px,80px)}85.36%{transform:translate(672px,96px)}93.46%{transform:translate(256px,96px)}94.08%{transform:translate(256px,64px)}94.39%{transform:translate(240px,64px)}95.02%{transform:translate(240px,32px)}96.57%{transform:translate(160px,32px)}96.88%{transform:translate(160px,16px)}97.51%{transform:translate(128px,16px)}97.82%{transform:translate(128px,0px)}99.07%{transform:translate(64px,0px)}99.38%{transform:translate(64px,-16px)}}.s.s3{transform:translate(48px,-16px);animation-name:s3}")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 2,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 2,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 2,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 2,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 2,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 2,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 2,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 18,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 18,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 18,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 18,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 18,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 18,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 18,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 34,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 34,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 34,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 34,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 34,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 34,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 34,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 50,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "c c0",
    x: 50,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 50,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 50,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 50,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 50,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 50,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 66,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 66,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 66,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 66,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 66,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 66,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 66,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 82,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 82,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 82,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 82,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 82,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 82,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 82,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 98,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 98,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 98,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 98,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 98,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 98,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 98,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 114,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 114,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 114,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 114,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 114,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 114,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 114,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 130,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 130,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 130,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 130,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 130,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 130,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 130,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 146,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 146,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 146,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 146,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 146,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 146,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 146,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 162,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 162,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 162,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 162,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 162,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 162,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 162,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 178,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 178,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 178,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 178,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 178,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 178,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 178,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 194,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 194,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 194,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 194,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 194,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 194,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 194,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 210,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 210,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 210,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 210,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 210,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 210,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 210,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 226,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 226,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 226,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 226,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 226,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 226,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 226,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 242,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 242,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 242,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 242,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 242,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 242,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 242,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 258,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 258,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 258,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 258,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 258,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 258,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 258,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 274,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 274,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 274,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 274,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 274,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 274,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 274,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 290,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 290,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 290,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 290,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 290,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 290,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1",
    x: 290,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    className: "c c2",
    x: 306,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 306,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 306,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 306,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 306,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 306,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 306,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 322,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 322,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 322,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 322,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 322,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 322,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    className: "c c3",
    x: 322,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    className: "c c4",
    x: 338,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 338,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 338,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    className: "c c5",
    x: 338,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 338,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 338,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    className: "c c6",
    x: 338,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    className: "c c7",
    x: 354,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 354,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 354,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 354,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    className: "c c8",
    x: 354,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 354,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    className: "c c9",
    x: 354,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    className: "c ca",
    x: 370,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    className: "c cb",
    x: 370,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    className: "c cc",
    x: 370,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    className: "c cd",
    x: 370,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 370,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    className: "c ce",
    x: 370,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    className: "c cf",
    x: 370,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 386,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    className: "c cg",
    x: 386,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    className: "c ch",
    x: 386,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 386,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    className: "c ci",
    x: 386,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    className: "c cj",
    x: 386,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 386,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 402,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    className: "c ck",
    x: 402,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 402,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 402,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    className: "c cl",
    x: 402,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 402,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    className: "c cm",
    x: 402,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 418,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 418,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 418,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    className: "c cn",
    x: 418,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 418,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 418,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    className: "c co",
    x: 418,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    className: "c cp",
    x: 434,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 434,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    className: "c cq",
    x: 434,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 434,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 434,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 434,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 434,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 450,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 450,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 450,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 450,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 450,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 450,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 450,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 466,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 466,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 466,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 466,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 466,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 466,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    className: "c cr",
    x: 466,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 482,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 482,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 482,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 482,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 482,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    className: "c cs",
    x: 482,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 482,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 498,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 498,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 498,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 498,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 498,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 498,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    className: "c ct",
    x: 498,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    className: "c cu",
    x: 514,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 514,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 514,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    className: "c cv",
    x: 514,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 514,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 514,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    className: "c cw",
    x: 514,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    className: "c cx",
    x: 530,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    className: "c cy",
    x: 530,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    className: "c cz",
    x: 530,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 530,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    className: "c c10",
    x: 530,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    className: "c c11",
    x: 530,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 530,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    className: "c c12",
    x: 546,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    className: "c c13",
    x: 546,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 546,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    className: "c c14",
    x: 546,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 546,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 546,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 546,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 562,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 562,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    className: "c c15",
    x: 562,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 562,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 562,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    className: "c c16",
    x: 562,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 562,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 578,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 578,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 578,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 578,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 578,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 578,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 578,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 594,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 594,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 594,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 594,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 594,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 594,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 594,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    className: "c c17",
    x: 610,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 610,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 610,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    className: "c c18",
    x: 610,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    className: "c c19",
    x: 610,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 610,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1a",
    x: 610,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 626,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 626,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1b",
    x: 626,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 626,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 626,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1c",
    x: 626,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 626,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 642,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1d",
    x: 642,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 642,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 642,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 642,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 642,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 642,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 658,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1e",
    x: 658,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 658,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 658,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 658,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 658,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1f",
    x: 658,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1g",
    x: 674,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 674,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1h",
    x: 674,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 674,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1i",
    x: 674,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1j",
    x: 674,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1k",
    x: 674,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 690,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 690,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 690,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1l",
    x: 690,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 690,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 690,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1m",
    x: 690,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1n",
    x: 706,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 706,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 706,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 706,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1o",
    x: 706,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1p",
    x: 706,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1q",
    x: 706,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1r",
    x: 722,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 722,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1s",
    x: 722,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 722,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 722,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 722,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 722,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 738,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 738,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 738,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 738,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 738,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 738,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 738,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 754,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 754,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 754,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 754,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 754,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 754,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 754,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 770,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 770,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 770,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 770,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 770,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 770,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1t",
    x: 770,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1u",
    x: 786,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 786,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 786,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 786,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 786,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 786,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect350 || (_rect350 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 786,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect351 || (_rect351 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1v",
    x: 802,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect352 || (_rect352 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 802,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect353 || (_rect353 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 802,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect354 || (_rect354 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 802,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect355 || (_rect355 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 802,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect356 || (_rect356 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 802,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect357 || (_rect357 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 802,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect358 || (_rect358 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 818,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect359 || (_rect359 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 818,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect360 || (_rect360 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1w",
    x: 818,
    y: 34,
    rx: 2,
    ry: 2
  })), _rect361 || (_rect361 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 818,
    y: 50,
    rx: 2,
    ry: 2
  })), _rect362 || (_rect362 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 818,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect363 || (_rect363 = /*#__PURE__*/React.createElement("rect", {
    className: "c c1x",
    x: 818,
    y: 82,
    rx: 2,
    ry: 2
  })), _rect364 || (_rect364 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 818,
    y: 98,
    rx: 2,
    ry: 2
  })), _rect365 || (_rect365 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 834,
    y: 2,
    rx: 2,
    ry: 2
  })), _rect366 || (_rect366 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 834,
    y: 18,
    rx: 2,
    ry: 2
  })), _rect367 || (_rect367 = /*#__PURE__*/React.createElement("rect", {
    className: "u u0",
    height: 12,
    width: 594.2,
    x: 0,
    y: 144
  })), _rect368 || (_rect368 = /*#__PURE__*/React.createElement("rect", {
    className: "u u1",
    height: 12,
    width: 12.7,
    x: 593.6,
    y: 144
  })), _rect369 || (_rect369 = /*#__PURE__*/React.createElement("rect", {
    className: "u u2",
    height: 12,
    width: 12.7,
    x: 605.7,
    y: 144
  })), _rect370 || (_rect370 = /*#__PURE__*/React.createElement("rect", {
    className: "u u3",
    height: 12,
    width: 146,
    x: 617.8,
    y: 144
  })), _rect371 || (_rect371 = /*#__PURE__*/React.createElement("rect", {
    className: "u u4",
    height: 12,
    width: 36.9,
    x: 763.2,
    y: 144
  })), _rect372 || (_rect372 = /*#__PURE__*/React.createElement("rect", {
    className: "u u5",
    height: 12,
    width: 49.1,
    x: 799.5,
    y: 144
  })), _rect373 || (_rect373 = /*#__PURE__*/React.createElement("rect", {
    className: "s s0",
    x: 0.8,
    y: 0.8,
    width: 14.4,
    height: 14.4,
    rx: 4.5,
    ry: 4.5
  })), _rect374 || (_rect374 = /*#__PURE__*/React.createElement("rect", {
    className: "s s1",
    x: 1.8,
    y: 1.8,
    width: 12.3,
    height: 12.3,
    rx: 4.1,
    ry: 4.1
  })), _rect375 || (_rect375 = /*#__PURE__*/React.createElement("rect", {
    className: "s s2",
    x: 2.6,
    y: 2.6,
    width: 10.8,
    height: 10.8,
    rx: 3.6,
    ry: 3.6
  })), _rect376 || (_rect376 = /*#__PURE__*/React.createElement("rect", {
    className: "s s3",
    x: 3,
    y: 3,
    width: 9.9,
    height: 9.9,
    rx: 3.3,
    ry: 3.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitsvg);
export default __webpack_public_path__ + "static/media/gitsvg.e79898f89d8d1bf9465d2191f5bbfd7a.svg";
export { ForwardRef as ReactComponent };